// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1WKAa","overflowing":"ReadFullNote_overflowing__1nySW"};